import * as React from "react";
const SvgFiRrTirePressureWarning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tire-pressure-warning_svg__a)">
      <path
        fill="#062147"
        d="M11 12V4a1 1 0 0 1 2 0v8a1 1 0 0 1-2 0m13 .429a12.06 12.06 0 0 0-2.638-7.613A6.07 6.07 0 0 1 20 1a1 1 0 0 0-1-1c-2.3.255-.16 5.038.8 6.064A9.42 9.42 0 0 1 17.715 20H6.287A9.426 9.426 0 0 1 4.2 6.064C5.155 5.048 7.306.252 5 0a1 1 0 0 0-1 1 6.07 6.07 0 0 1-1.362 3.816A11.41 11.41 0 0 0 5 21.544V23a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1.456a11.3 11.3 0 0 0 5-9.115M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tire-pressure-warning_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTirePressureWarning;
